import {Loader} from "@googlemaps/js-api-loader";
import {environment} from "@mri/environment";

function getMapApiKey(): string{

  const keys = environment.googleMap.apiKeys;

  const daysInMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
  const count = keys.length;
  const daysForKey = Math.ceil(daysInMonth / count);

  const keyIndex = Math.ceil(new Date().getDate() / daysForKey) - 1;

  (window as any).currentMapKey = keys[keyIndex];
  console.log(`Map API Key: ${keys[keyIndex]}`);
  return keys[keyIndex];
}

export const googleMapLoader = new Loader({
    apiKey: getMapApiKey(),
    version: 'weekly',
    libraries: ['places', 'streetView', 'maps', 'routes', 'drawing']
});
